<template>
  <div class="results-per-page">
    <i class="fa fa-th-list"></i>

    <template v-for="(option, index) in options">
      <template v-if="index > 0"><span :key="option">|</span></template>
      <router-link :to="createResultsPerPageLink(option)"
        :class="[ option ==  resultsPerPage ? 'active' : '']" :key="index">{{ option }}</router-link>
    </template>

<!--     <router-link to=" createResultsPerPageLink(20) ">20</router-link> <span>|</span> 
    <router-link to=" createResultsPerPageLink(50) ">50</router-link> <span>|</span> 
    <router-link to=" createResultsPerPageLink(100) ">100</router-link> -->

  </div>
</template>

<i18n>
{
  "es": {
  },
  "en": {
    "": ""  
  },
  "ca": {
    "": ""
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
			}
		},
    computed: mapGetters({
      resultsPerPage: 'getResultsPerPage',
      options: 'getOptionsResultsPerPage',
      query: 'getQuery'
    }),
    methods: {
      createResultsPerPageLink(option){
        var tmp = Object.assign({}, this.query);
        return ( { query: Object.assign(tmp, { rpp: option, p: 1 }) } );
      }
    },
    watch: {
      resultsPerPage: function() { 
        this.resultsPerPage = this.getResultsPerPage;
      }
    }
  }
</script>
